import { render, staticRenderFns } from "./userValidations.vue?vue&type=template&id=2971d91a&scoped=true"
import script from "./userValidations.vue?vue&type=script&lang=js"
export * from "./userValidations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971d91a",
  null
  
)

export default component.exports